import {
  CapaErrorCode,
  CapaQuotationChatMessage,
  CapaQuotationChatMessageType,
  CapaQuotationUserType,
  FetchQuotationChatMessagesQuery,
  FetchQuotationChatMessagesQueryVariables
} from '@generated/graphql';
import { graphql } from 'msw';
import { v4 } from 'uuid';

const PAYMENT_CHAT_MESSAGE_TYPE = Object.values(CapaQuotationChatMessageType);

const fetchQuotationChatMessages = graphql.query<
  FetchQuotationChatMessagesQuery,
  FetchQuotationChatMessagesQueryVariables
>('fetchQuotationChatMessages', (req, res, context) => {
  const purchaseOrderId = v4();
  const quotationId = v4();
  const rfqId = v4();
  const quotationUserId = v4();

  return res(
    context.data({
      __typename: 'Query',
      fetchQuotationChatMessages: {
        __typename: 'CAPAQuotationChatMessagesOutput',
        result: CapaErrorCode.Success,
        errorMessage: null,
        data: PAYMENT_CHAT_MESSAGE_TYPE.map(
          (type) =>
            ({
              __typename: 'CAPAQuotationChatMessage',
              chatFiles: null,
              createdAt: new Date().toISOString(),
              id: v4(),
              managerName: '유저이름',
              organizationName: '유저회사명',
              profileId: null,
              senderId: quotationUserId,
              senderUserType: CapaQuotationUserType.Client,
              status: null,
              unReadCount: 1,
              message: {
                __typename: 'CAPAQuotationChatMessageRfq',
                messageType: type,
                rfq: {
                  __typename: 'CAPAQuotationChatRfq',
                  adjustRequest: null,
                  event: null,
                  expectedConfirmPurchaseDate: new Date().toISOString(),
                  isSendRequest: false,
                  isVisible: true,
                  partnerManagerName: '파트너담당자명',
                  partnerOrganizationName: '파트너회사명',
                  projectName: '프로젝트명',
                  purchaseAmount: 21500,
                  purchaseOrderId: purchaseOrderId,
                  quotationId,
                  rfqId,
                  rejectedReason:
                    'Lorem ipsum dolor sit amet consectetur adipisicing elit. Aut corrupti quibusdam quos facilis impedit! Doloremque labore nisi culpa, excepturi et deserunt, doloribus ex numquam fugiat recusandae porro. Aliquam, expedita ullam? Lorem ipsum dolor sit amet consectetur adipisicing elit. Aut corrupti quibusdam quos facilis impedit! Doloremque labore nisi culpa, excepturi et deserunt, doloribus ex numquam fugiat recusandae porro. Aliquam, expedita ullam?',
                  userManagerName: '유저이름',
                  userOrganizationName: '유저회사명'
                }
              }
            } as CapaQuotationChatMessage)
        )
      }
    })
  );
});

export default fetchQuotationChatMessages;
